import { SelectOutlined } from "@ant-design/icons";
import { Alert, Button, Col, Result, Row } from "antd";
import React from "react";

// Anything can be thrown, not only an Error, so show something readable either way
const errorMessage = (error) => {
  if (typeof error?.message === "string" && error.message) return error.message;
  if (typeof error === "string" && error) return error;
  return "Unknown error";
};

// The "Something went wrong" page. It doesn't depend on the router, so it can be shown
// for errors that happen outside it as well as for a page that fails inside it.
const ErrorPage = ({ error, onGoHome }) => (
  <Result
    status="error"
    title="Something went wrong"
    subTitle="An unexpected error has occurred."
    extra={
      <Row justify="center">
        <Col style={{ maxWidth: 850 }}>
          <Alert
            message={errorMessage(error)}
            showIcon
            description={typeof error?.stack === "string" ? error.stack : null}
            type="error"
            style={{ textAlign: "start" }}
            action={
              <Button size="small" danger onClick={onGoHome}>
                <SelectOutlined />
                Go Home
              </Button>
            }
          />
        </Col>
      </Row>
    }
  />
);

export default ErrorPage;
